import React, { createContext, useContext, useState, useCallback } from 'react';
import { 
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    ThemeProvider,
    createTheme
} from '@mui/material';

const ConfirmationDialogContext = createContext();

export const useConfirmationDialog = () => {
    return useContext(ConfirmationDialogContext);
};

export const ConfirmationDialogProvider = ({ children }) => {
    const darkTheme = createTheme({
        palette: {
            mode: 'dark'
        }
    });

    const [dialogState, setDialogState] = useState({
        isOpen: false,
        title: '',
        message: '',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: 'primary',
        cancelButtonColor: 'inherit',
        maxWidth: 'xs',
        fullWidth: true,
        scroll: 'body',
        onConfirm: () => {},
        onCancel: () => {}
    });

    const openConfirmationDialog = useCallback(({
        title,
        message,
        confirmButtonText = 'Confirmar',
        cancelButtonText = 'Cancelar',
        confirmButtonColor = 'primary',
        cancelButtonColor = 'inherit',
        maxWidth = 'xs',
        fullWidth = true,
        scroll = 'body',
        onConfirm,
        onCancel
    }) => {
        setDialogState({
            isOpen: true,
            title,
            message,
            confirmButtonText,
            cancelButtonText,
            confirmButtonColor,
            cancelButtonColor,
            maxWidth,
            fullWidth,
            scroll,
            onConfirm: () => {
                if (onConfirm) onConfirm();
                setDialogState(prev => ({ ...prev, isOpen: false }));
            },
            onCancel: () => {
                if (onCancel) onCancel();
                setDialogState(prev => ({ ...prev, isOpen: false }));
            }
        });
    }, []);

    const closeConfirmationDialog = useCallback(() => {
        setDialogState(prev => ({ ...prev, isOpen: false }));
    }, []);

    return (
        <ConfirmationDialogContext.Provider value={{ openConfirmationDialog, closeConfirmationDialog }}>
            {children}
            <ThemeProvider theme={darkTheme}>
                <Dialog
                    open={dialogState.isOpen}
                    onClose={dialogState.onCancel}
                    maxWidth={dialogState.maxWidth}
                    fullWidth={dialogState.fullWidth}
                    scroll={dialogState.scroll}     
                >
                    <DialogTitle>{dialogState.title}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {dialogState.message}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{ px: 3, pb: 2 }}>
                        <Button 
                            onClick={dialogState.onCancel} 
                            color={dialogState.cancelButtonColor}
                            variant="outlined"
                        >
                            {dialogState.cancelButtonText}
                        </Button>
                        <Button 
                            onClick={dialogState.onConfirm} 
                            color={dialogState.confirmButtonColor}
                            variant="contained"
                            autoFocus
                        >
                            {dialogState.confirmButtonText}
                        </Button>
                    </DialogActions>
                </Dialog>
            </ThemeProvider>
        </ConfirmationDialogContext.Provider>
    );
};
